import { func } from 'prop-types';
import { useContext, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { BenefitsContext, Card, FormCheckbox, Skeleton } from 'components';
import { formatLocalizedCurrency, normalizeStr } from 'helpers';

const FiscalModal = ({ setIsFiscalModalOpen }) => {
  const { t } = useTranslation();
  const { taxeMinusTwoYear, taxesLoading } = useContext(BenefitsContext);

  useEffect(() => {
    setFieldData();
  }, [taxeMinusTwoYear]);

  const openFiscalModal = () => {
    setIsFiscalModalOpen(true);
  };

  const { register, setValue, getValues, trigger, control, formState } = useForm({
    mode: 'all',
    defaultValues: {
      singleParent: taxeMinusTwoYear?.singleParent,
      handicap: taxeMinusTwoYear?.handicap
    }
  });

  const providerValues = { register, setValue, getValues, formState, control };

  const setFieldData = () => {
    setValue('handicap', taxeMinusTwoYear?.handicap);
    setValue('singleParent', taxeMinusTwoYear?.singleParent);
    trigger();
  };

  return taxesLoading ? (
    <Skeleton classNames="h-96 w-full mt-8 " />
  ) : (
    <Card onMobile={false} className="mt-8 lg:col-span-3">
      <h2 className="h2 underlined-yellow mb-8"> {t('dashboard:benefits.fiscalDatas')}</h2>

      <div className="grid grid-cols-12 w-full items-center gap-4 mb-5">
        <p className="label col-span-6"> {t('form:referenceTaxIncome')}</p>
        <p className="col-span-6 text-right">
          {formatLocalizedCurrency(taxeMinusTwoYear?.income) || t('dashboard:benefits.noFiscalData')}
        </p>
      </div>
      <div className="grid grid-cols-12 w-full gap-4 items-end mb-5">
        <p className="label col-span-6"> {t('form:overseasDepartment')}</p>
        <p className="col-span-6 text-right"> {taxeMinusTwoYear?.department || t('dashboard:benefits.noFiscalData')}</p>
      </div>
      <FormProvider {...providerValues}>
        <FormCheckbox name="handicap" labelI18nKey="form:beneficiary" className="mb-4 disabled" disabled={true} />
        <FormCheckbox
          name="singleParent"
          labelI18nKey="form:monoparentalFamily"
          className="mb-4 disabled"
          disabled={true}
        />
      </FormProvider>

      <div className="grid grid-cols-12 w-full gap-4 items-end mb-5">
        <p className="label col-span-6"> {t('form:taxNumber')}</p>
        <p className="col-span-6 text-right"> {taxeMinusTwoYear?.nbParts || t('dashboard:benefits.noFiscalData')}</p>
      </div>
      <div className="grid grid-cols-12 w-full gap-4 items-end mb-5">
        <p className="label col-span-6"> {t('form:familyQuotient')}</p>
        <p className="col-span-6 text-right">
          {formatLocalizedCurrency(taxeMinusTwoYear?.fq) || t('dashboard:benefits.noFiscalData')}
        </p>
      </div>
      {normalizeStr(taxeMinusTwoYear?.status) === normalizeStr('Validé') ? (
        <p className="font-bold">
          {t('dashboard:benefits.fiscalDatasInfo')}{' '}
          <a href="mailto:support@touloisirs.fr" className="underline hover:no-underline">
            support@touloisirs.fr
          </a>
        </p>
      ) : (
        <div className="flex justify-end">
          <button type="button" className="btn mt-4" onClick={() => openFiscalModal()}>
            {t('buttons.modify')}
          </button>
        </div>
      )}
    </Card>
  );
};

FiscalModal.propTypes = {
  setIsFiscalModalOpen: func.isRequired
};

export default FiscalModal;
